<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      operState: 0, // 判断是新增还是编辑的数据回显
      currentLine: {}, // 列表当前行的信息
      towCurrentLine:{}, // 个体练习情况当前行信息
    };
  },
  components: {
    CertifiedHosp: () => import("./components/page.vue"),
    TheApproved: () => import("./components/queryPage.vue"),
    TheEditor: () => import("./components/record.vue"),
    // Encryption: () => import("./components/Protect.vue"),
    // testsope: () => import("./components/testcope.vue"),
    // DecryTable: () => import("./components/encryption/decryTable.vue"),
    // ModifyThe: () => import("../../layout/components/userCenter/index.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "TheApproved";
        case 2:
          return "TheEditor";
        // case 4:
        //   return "testsope";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
  },
};
</script>